import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { faEdit } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { TwoColumn } from 'components/layout'

interface ApprovalGroupSectionProps {
  employee: TWorker | undefined
  onEdit?: () => void
}

export const ApprovalGroupSection: FC<ApprovalGroupSectionProps> = ({
  employee,
  onEdit,
}) => {
  const { t } = useTranslation()

  const approvalGroupName =
    employee?.approvalGroup?.name ?? t('common.notAvailable')

  return (
    <TwoColumn
      label={t('common.approvalGroup')}
      description={t('features.usersAdmin.userDetails.approvalGroupDescription')}
    >
      <div className="w-[825px]">
        <div className="flex flex-row items-center justify-between gap-2 w-[230px] h-14 px-4 border rounded-lg bg-neutral-100 border-neutral-200">
          <span
            className="text-sm truncate text-neutral-900"
            title={approvalGroupName}
          >
            {approvalGroupName}
          </span>
          {onEdit && (
            <button
              type="button"
              onClick={onEdit}
              className="flex items-center gap-2 text-sm font-medium shrink-0 text-primary-600 hover:text-primary-700"
            >
              <FontAwesomeIcon icon={faEdit} />
              {t('common.edit')}
            </button>
          )}
        </div>
      </div>
    </TwoColumn>
  )
}
